import templateUrl from 'emun.map/county-view.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class CountyViewController  {
    constructor($scope, $geo, $http, leafletData) {
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.token = 'pk.eyJ1IjoiYnJhbmRvbmx1c2siLCJhIjoiY2pmMWk2M2ZtMGUwcjJxbG5udTF1MGlzYyJ9.GFvALV_-d7a6aNuppmAhaw';
		$ctrl.center = {
			lat: 37.0902,
			lng: -95.7129,
			zoom: 4
		}
		$ctrl.tiles = {
			name: 'Mapbox Park',
			url: 'http://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
			type: 'xyz',
			options: {
				apikey: $ctrl.token,
				mapid: 'mapbox.light'
			}
		}
		$ctrl.fills = {
			'HIGH': '#3182bd',
			'MEDIUM': '#9ecae1',
			'LOW': '#deebf7',
			'defaultFill': '#DDDDDD'
		}
		$ctrl.geojson = {};
		$ctrl.$geo = $geo;
		$ctrl.leafletData = leafletData;
		$ctrl.selectedState = {};



		$http.get("https://s3.amazonaws.com/emuncloud-staticassets/mapfiles/usa-state-counties-small.json").success(function (data, status) {
					$ctrl.style = function (feature) {
						return {
							fillColor: '#3182bd',
							weight: 1,
							opacity: 1,
							color: 'white',
							dashArray: '1',
							fillOpacity: 0.7
						};
					}
					$ctrl.geojson = {
						data: data,
						style: $ctrl.style,
						resetStyleOnMouseout: true
					}
		});

	}
}

let CountyView = {
    controller: CountyViewController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default CountyView;